import Appearance from "./Appearance"
import SettingsCard from "./SettingsCard"
import LanguagePicker from "./LanguagePicker"
import Modal from "components/modal"
import useUnsavedStore from "stores/unsaved"
import useMediaQuery from "utils/useMediaQuery"

export const Settings = () => {
  const isDesktop = useMediaQuery("(min-width: 900px)")
  const openLanguageSheet = useUnsavedStore((state) => state.openLanguageSheet)
  const openAppearanceSheet = useUnsavedStore(
    (state) => state.openAppearanceSheet,
  )
  const toggleAppearanceSheet = useUnsavedStore(
    (state) => state.toggleAppearanceSheet,
  )
  const toggleLanguageSheet = useUnsavedStore(
    (state) => state.toggleLanguageSheet,
  )

  return (
    <>
      <Modal
        isCenter={isDesktop}
        modalOpen={openLanguageSheet}
        close={toggleLanguageSheet}
      >
        <LanguagePicker />
      </Modal>
      <Modal
        isCenter={isDesktop}
        modalOpen={openAppearanceSheet}
        close={toggleAppearanceSheet}
      >
        <Appearance />
      </Modal>
      <SettingsCard />
    </>
  )
}
export default Settings
